import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedTitleServiceService {

  private setTitle = new BehaviorSubject('');
  currentTitle = this.setTitle.asObservable();

  constructor() { }

  setTitleFunction(newTitle) {
    this.setTitle.next(newTitle);
  }
}
